import {paymentProviderTypes, paymentStatusTypes} from 'app/constant'
import {orderActions} from 'app/constant/order'
import {orderStatus} from 'app/features/orders/models'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {getAppProfile} from 'app/utilities'
import remove from 'lodash/remove'

const description: string =
  "This will change the order status. It won't send an email notification or charge/refund. Do you want to continue?"

export const actionTypes = [
  {
    name: 'Refund and Restock inventory',
    value: orderActions.refundAndRestock,
    showEmail: true,
    message: 'Do you want to process Refund and Restock inventory',
    title: 'Refunded and Restock',
  },
  {
    name: 'Refund and DO NOT Restock inventory',
    value: orderActions.refundOnly,
    message: 'Do you want to process Refund and DO NOT Restock inventory',
    title: 'Refunded',
  },
  {
    name: 'Restock Only',
    value: orderActions.restockOnly,
    message: 'Do you want to process Restock Only',
    title: 'Restock',
  },
  {
    name: 'Mark as Unfulfilled Without Notification',
    value: orderActions.fulfilledToUnfulfilled,
    subtitle: ' issuing a tracking number or ',
    description,
    actionLabel: 'Fulfilled to Unfulfilled',
    title: 'Unfulfilled',
  },
  {
    name: 'Mark as Unfulfilled Without Notification',
    value: orderActions.restockedToUnfulfilled,
    subtitle: ' issuing a tracking number or ',
    description,
    actionLabel: 'Restocked to Unfulfilled',
    title: 'Unfulfilled',
  },
  {
    name: 'Mark as Restocked Without Notification',
    value: orderActions.fulfilledToRestocked,
    subtitle: ' issuing a refund number or ',
    description,
    actionLabel: 'Fulfilled to Restocked',
    title: 'Restock',
  },
  {
    name: 'Mark as Fulfilled Without Notification',
    value: orderActions.unfulfilledToFulfilled,
    subtitle: ' issuing a tracking number or ',
    description,
    actionLabel: 'Unfulfilled to Fulfilled',
    title: 'Fulfilled',
  },
  {
    name: 'Mark as Fulfilled Without Notification',
    value: orderActions.readyToFulfillToFulfilled,
    subtitle: ' issuing a tracking number or ',
    description,
    actionLabel: 'Ready to fulfill to Fulfilled',
    title: 'Fulfilled',
  },
  {
    name: 'Mark as Unfulfilled Without Notification',
    value: orderActions.readyToFulfillToUnFulfilled,
    subtitle: ' issuing a tracking number or ',
    description,
    actionLabel: 'Ready to fulfill to Unfulfilled',
    title: 'Unfulfilled',
  },
]

const filterActions = (actions: any[], filters: any[]) =>
  remove(actions, (item) => filters.includes(item.value))

export const mapToPosOrderActionModel = (order: ViewOrder) => {
  const actions = [...actionTypes]
  if (
    order.fulfillmentStatus === orderStatus.restocked &&
    order.financialStatus === paymentStatusTypes.paid
  ) {
    return filterActions(actions, [orderActions.refundAndRestock])
  }

  if (order.isAdminEnabledPosCancel) {
    let items: any[] = []
    if (
      order.paymentProviderType === paymentProviderTypes.elavon &&
      order.isIncludedScannerTransaction
    ) {
      items = []
    } else {
      items = [orderActions.refundAndRestock]
    }
    if (order.fulfillmentStatus === orderStatus.fulfilled) {
      items.push(orderActions.fulfilledToRestocked)
    }
    return filterActions(actions, items)
  }
  return []
}

export const mapToMigrationActionModel = (order: ViewOrder) => {
  const actions = [...actionTypes]
  switch (order.fulfillmentStatus) {
    case orderStatus.unfulfilled:
      return filterActions(actions, [
        // orderActions.refundAndRestock,
        orderActions.unfulfilledToFulfilled,
      ])

    case orderStatus.fulfilled:
      return filterActions(actions, [
        orderActions.fulfilledToUnfulfilled,
        orderActions.fulfilledToRestocked,
      ])

    case orderStatus.readyToFulfill:
      return filterActions(actions, [
        orderActions.readyToFulfillToFulfilled,
        orderActions.readyToFulfillToUnFulfilled,
      ])

    case orderStatus.restocked:
      return filterActions(actions, [orderActions.restockedToUnfulfilled])

    default:
      return []
  }
}

export const mapToOrderActionModel = (
  order: ViewOrder,
  hideRefundAndRestock: boolean,
  isRestockedOrder: boolean
) => {
  const actions = [...actionTypes]
  const isUnfulfilled = order.fulfillmentStatus === orderStatus.unfulfilled
  const isPartialRefunded = order.financialStatus === paymentStatusTypes.partialRefund
  const isRestocked = order.fulfillmentStatus === orderStatus.restocked
  const isPaid = order.financialStatus === paymentStatusTypes.paid
  const isReadyToFulfill = order.fulfillmentStatus === orderStatus.readyToFulfill
  const isFulfilled = order.fulfillmentStatus === orderStatus.fulfilled
  const isPartialFulfilled = order.fulfillmentStatus === orderStatus.partialFulfilled

  if (isRestocked && isPartialRefunded && isRestockedOrder) {
    return filterActions(actions, [orderActions.refundOnly])
  }

  if (isRestocked && isPartialRefunded) {
    return filterActions(actions, [
      orderActions.refundAndRestock,
      orderActions.restockOnly,
      orderActions.refundOnly,
    ])
  }

  if (isRestocked && isPaid) {
    return filterActions(actions, [orderActions.restockedToUnfulfilled, orderActions.refundOnly])
  }

  if (isPartialFulfilled) {
    return filterActions(actions, [
      orderActions.refundAndRestock,
      orderActions.restockOnly,
      orderActions.refundOnly,
    ])
  }

  if (isReadyToFulfill) {
    return filterActions(actions, [
      orderActions.readyToFulfillToFulfilled,
      orderActions.readyToFulfillToUnFulfilled,
      orderActions.refundAndRestock,
      orderActions.restockOnly,
      orderActions.refundOnly,
    ])
  }

  if (isUnfulfilled) {
    return filterActions(actions, [
      orderActions.unfulfilledToFulfilled,
      orderActions.refundAndRestock,
      orderActions.restockOnly,
      orderActions.refundOnly,
    ])
  }

  if (isFulfilled) {
    const actionItems = [
      orderActions.fulfilledToRestocked,
      orderActions.refundAndRestock,
      orderActions.restockOnly,
    ]
    if (!isPartialRefunded) {
      actionItems.push(orderActions.fulfilledToUnfulfilled)
    }

    return filterActions(actions, actionItems)
  }

  if (hideRefundAndRestock) {
    return remove(actions, (item) => item.value !== orderActions.refundAndRestock)
  }

  return []
}
